import 'es6-promise/auto';
import '@/assets/styles/main.css';
import { createApp } from 'vue';
import VueApexCharts from "vue3-apexcharts";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import vuetify from '@/plugins/vuetify';
import { router } from '@/plugins/router';
import App from '@/App.vue'


const app = createApp(App);
const pinia = createPinia();


pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(VueApexCharts);
app.use(VueSweetalert2);

app.mount('#app');
